export default __webpack_public_path__ + "static/media/ic-serach-purple.7df9d800.svg";